"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptConfigParams = void 0;
/* eslint-disable no-empty */
var getScriptUrl_1 = require("./getScriptUrl");
function getScriptConfigParams() {
    var dataAttributesParams = getParamsFromDataAttributes();
    if (dataAttributesParams) {
        return dataAttributesParams;
    }
    var searchParamsParams = getParamsFromSearchParams();
    if (searchParamsParams) {
        return searchParamsParams;
    }
    return {};
}
exports.getScriptConfigParams = getScriptConfigParams;
function getParamsFromDataAttributes() {
    var currentScript = document.currentScript;
    if (!currentScript) {
        return;
    }
    var projectName = currentScript.getAttribute('data-projectName');
    if (!projectName) {
        return;
    }
    return { projectName: projectName };
}
function getParamsFromSearchParams() {
    var scriptSrc = (0, getScriptUrl_1.getScriptUrl)();
    if (!scriptSrc) {
        return;
    }
    if (scriptSrc.startsWith('//')) {
        scriptSrc = "https:".concat(scriptSrc);
    }
    var scriptURL = new URL(scriptSrc);
    var projectName = scriptURL.searchParams.get('projectName');
    if (!projectName) {
        return;
    }
    return { projectName: projectName };
}
//# sourceMappingURL=getScriptConfigParams.js.map